import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface ItemGroupResponse {
    group_id?: number | null;
    group_code?: string | null;
    group_name?: string | null;
    group_icon?: string | null;
    group_saccno?: string | null;
    group_caccno?: string | null;
    group_iaccno?: string | null;
    group_prchadays?: number | null;
    group_reorder?: number | null;
    group_crby?: string | null;
    group_crat?: string | null;
    group_mdby?: string | null;
    group_mdat?: string | null;
}

export type ItemGroupCreateUpdateRequest = Omit<ItemGroupResponse, "group_id" | "group_crat" | "group_crby" | "group_mdby" | "group_mdat">;

export const getAllItemGroups = async (): Promise<ItemGroupResponse[]> => {
    try {
        const response: ApiResponse<ItemGroupResponse[] | null> = (
            await apiClient.get("/pos_item_group/all", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.status === 401) {
            throw new Error("Not authorized to load item groups. Please sign in with backend authentication.");
        }

        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to fetch item groups");
    }
};

export const createItemGroup = async (groupData: ItemGroupCreateUpdateRequest): Promise<ItemGroupResponse> => {
    try {
        const response: ApiResponse<ItemGroupResponse> = (
            await apiClient.post("/pos_item_group/create", groupData, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        if (!response.data) {
            throw new Error("Failed to create item group - no data returned");
        }

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to create item group");
    }
};

export const updateItemGroup = async (groupId: number, groupData: ItemGroupCreateUpdateRequest): Promise<ItemGroupResponse> => {
    try {
        const response: ApiResponse<ItemGroupResponse> = (
            await apiClient.put(`/pos_item_group/update/${groupId}`, groupData, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        if (!response.data) {
            throw new Error("Failed to update item group - no data returned");
        }

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to update item group");
    }
};